"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelParamsHolder = void 0;
var enum_1 = require("@devexpress/utils/lib/utils/enum");
var log_source_1 = require("./log-source");
var log_source_params_1 = require("./log-source-params");
var ModelParamsHolder = (function () {
    function ModelParamsHolder() {
        var _this = this;
        this.logSourceParams = {};
        enum_1.EnumUtils.forEach(log_source_1.LogSource, function (keyNum) {
            _this.handle(keyNum);
        });
    }
    ModelParamsHolder.prototype.handle = function (logSourceKey) {
        this.logSourceParams[logSourceKey] = new log_source_params_1.LogSourceParams(false, logSourceKey);
    };
    return ModelParamsHolder;
}());
exports.ModelParamsHolder = ModelParamsHolder;
